/** shadcn:dialog — upstream synced via `pnpm dlx shadcn add dialog --diff` */

'use client';

import { c as _c } from "react/compiler-runtime";
import { Dialog as DialogPrimitive } from 'radix-ui';
import * as React from 'react';
import { IconClose } from '@/components/icons';
import { Button } from '@/components/ui/button';
import { ToolbarIconButton } from '@/components/ui/button-presets';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';
function Dialog(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DialogPrimitive.Root data-slot="dialog" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
Dialog.displayName = 'Dialog';
function DialogTrigger(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DialogPrimitive.Trigger data-slot="dialog-trigger" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
DialogTrigger.displayName = 'DialogTrigger';
function DialogPortal(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DialogPrimitive.Portal data-slot="dialog-portal" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
DialogPortal.displayName = 'DialogPortal';
function DialogClose(t0) {
  const $ = _c(4);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <DialogPrimitive.Close data-slot="dialog-close" {...props} />;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
DialogClose.displayName = 'DialogClose';
function DialogOverlay(t0) {
  const $ = _c(12);
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      overlayExcludeTitleBar: t1,
      aboveLoadingOverlay: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const overlayExcludeTitleBar = t1 === undefined ? true : t1;
  const aboveLoadingOverlay = t2 === undefined ? false : t2;
  const t3 = overlayExcludeTitleBar ? "top-(--titlebar-height) right-0 bottom-0 left-0" : "inset-0";
  const t4 = aboveLoadingOverlay && "z-100000";
  let t5;
  if ($[5] !== className || $[6] !== t3 || $[7] !== t4) {
    t5 = cn("fixed z-50 bg-black/50 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:animate-in data-[state=open]:fade-in-0", t3, "bg-[#1A1B1E]/70 backdrop-blur-xs", t4, className);
    $[5] = className;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== props || $[10] !== t5) {
    t6 = <DialogPrimitive.Overlay data-slot="dialog-overlay" className={t5} {...props} />;
    $[9] = props;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}
DialogOverlay.displayName = 'DialogOverlay';
function DialogContent(t0) {
  const $ = _c(29);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t0) {
    ({
      className,
      children,
      showCloseButton: t1,
      overlayExcludeTitleBar: t2,
      aboveLoadingOverlay: t3,
      preventInteractOutside: t4,
      hideOverlay: t5,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
  }
  const showCloseButton = t1 === undefined ? true : t1;
  const overlayExcludeTitleBar = t2 === undefined ? true : t2;
  const aboveLoadingOverlay = t3 === undefined ? false : t3;
  const preventInteractOutside = t4 === undefined ? true : t4;
  const hideOverlay = t5 === undefined ? false : t5;
  let t6;
  if ($[9] !== aboveLoadingOverlay || $[10] !== hideOverlay || $[11] !== overlayExcludeTitleBar) {
    t6 = !hideOverlay ? <DialogOverlay overlayExcludeTitleBar={overlayExcludeTitleBar} aboveLoadingOverlay={aboveLoadingOverlay} /> : null;
    $[9] = aboveLoadingOverlay;
    $[10] = hideOverlay;
    $[11] = overlayExcludeTitleBar;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = aboveLoadingOverlay && "z-100000";
  let t8;
  if ($[13] !== className || $[14] !== t7) {
    t8 = cn("fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border bg-background p-6 shadow-lg duration-200 outline-none data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95 sm:max-w-lg", "border-none bg-background backdrop-blur-[20px] gap-2 rounded-xl p-4", t7, className);
    $[13] = className;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== preventInteractOutside) {
    t9 = e => preventInteractOutside ? e.preventDefault() : undefined;
    $[16] = preventInteractOutside;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== showCloseButton) {
    t10 = showCloseButton ? <DialogPrimitive.Close data-slot="dialog-close" className="absolute top-2.5 right-2.5" asChild={true}><ToolbarIconButton size="symbol"><IconClose className="size-3.5" /><span className="sr-only">Close</span></ToolbarIconButton></DialogPrimitive.Close> : null;
    $[18] = showCloseButton;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== children || $[21] !== props || $[22] !== t10 || $[23] !== t8 || $[24] !== t9) {
    t11 = <DialogPrimitive.Content data-slot="dialog-content" className={t8} aria-describedby={undefined} onInteractOutside={t9} {...props}>{children}{t10}</DialogPrimitive.Content>;
    $[20] = children;
    $[21] = props;
    $[22] = t10;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t6) {
    t12 = <DialogPortal data-slot="dialog-portal">{t6}{t11}</DialogPortal>;
    $[26] = t11;
    $[27] = t6;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}
DialogContent.displayName = 'DialogContent';
function DialogHeader(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("flex flex-col gap-2 text-center sm:text-left", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <div data-slot="dialog-header" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
DialogHeader.displayName = 'DialogHeader';
function DialogFooter(t0) {
  const $ = _c(14);
  let children;
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      showCloseButton: t1,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
  }
  const showCloseButton = t1 === undefined ? false : t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== showCloseButton) {
    t3 = showCloseButton ? <DialogPrimitive.Close asChild={true}><Button>Close</Button></DialogPrimitive.Close> : null;
    $[7] = showCloseButton;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== children || $[10] !== props || $[11] !== t2 || $[12] !== t3) {
    t4 = <div data-slot="dialog-footer" className={t2} {...props}>{children}{t3}</div>;
    $[9] = children;
    $[10] = props;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
DialogFooter.displayName = 'DialogFooter';
type DialogTitleProps = React.ComponentProps<typeof DialogPrimitive.Title> & {
  // @genesys-start
  showSeparator?: boolean;
  // @genesys-end
};
const DialogTitle = t0 => {
  const $ = _c(14);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      showSeparator: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const showSeparator = t1 === undefined ? true : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("text-lg font-semibold leading-none", "text-2sm font-bold text-secondary-foreground", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== props || $[7] !== t2) {
    t3 = <DialogPrimitive.Title data-slot="dialog-title" className={t2} {...props} />;
    $[6] = props;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== showSeparator) {
    t4 = showSeparator ? <div className="-mx-4 my-1"><Separator className="bg-dialog-separator" /></div> : null;
    $[9] = showSeparator;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t3 || $[12] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
DialogTitle.displayName = 'DialogTitle';
function DialogDescription(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn("text-sm text-muted-foreground", "mb-4", className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <DialogPrimitive.Description data-slot="dialog-description" className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
DialogDescription.displayName = 'DialogDescription';
export { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger };